<template>
  <div class="text-disabled text-center py-5">В розробці</div>
</template>

<script lang="ts">
export default {
  name: 'History',
}
</script>

<style scoped lang="scss"></style>
